export default {
  title: 'Course',
  livingCourse: 'Live Courses',
  videoCourse: 'Video Courses',
  livingBar: {
    status: {
      notStarted: 'Not Started',
      living: 'Live...',
      ended: 'Ended',
      all: 'All',
    },
    timeLabels: {
      endTime: 'End Time',
      liveTime: 'Live Time',
    },
    actions: {
      watchReplay: 'Watch Replay',
      watchLive: 'Watch Live',
    },
    detail: {
      intro: 'Introduction:',
      messages: {
        replayNotGenerated: 'Replay not generated',
      },
    },
  },
  video: {
    categories: {
      preciousMetals: 'Precious Metals',
      forex: 'Forex',
      all: 'All',
    },
    actions: {
      viewCourse: 'View Course',
      startPlay: 'Start Playing',
    },
    detail: {
      intro: 'Introduction:',
      courseDetails: 'Course Details',
      courseCatalog: 'Course Catalog',
    },
    chapter: {
      videoCount: '{count} videos',
      messages: {
        watchFailed: 'Watch failed',
      },
    },
  },
  breadcrumb: {
    course: 'Course',
    courseDetails: 'Course Details',
  },
}
